import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState } from 'react';
import './i18n';

// Компоненты
import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import Services from './components/Services';
import KazakhMap from './components/KazakhstanMap';
import Partners from './components/Partners';
import ContactForm from './components/ContactForm';

// Скролл
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';

// О нас
import AboutPage from './pages/about/AboutPage';

// Видео
import VideoSolutions from './pages/video/VideoSolutions';
import MotorolaPage from './pages/video/MotorolaPage';
import WisenetPage from './pages/video/WisenetPage';
import MilestonePage from './pages/video/MilestonePage';
import RecFacesPage from './pages/video/RecFacesPage';

// Локально вычислительные системы
import LocalSystems from './pages/localsystems/LocalSystems';

// Антитеррор
import AntiterrorSystems from './pages/antiterror/AntiterrorSystems';

// Криминалистика 
import DigitalForensics from './pages/digitalforensics/DigitalForensics';

// Дроны
import DronesSection from './pages/DronesSection/DronesSection';

// Анти-БПЛА
import AntidroneSystems from './pages/antidronesystems/AntidroneSystems';

// СТС
import ProtectedRoute from './components/ProtectedRoute';
import STSPage from './pages/sts/STSPage';
import StsLogin from './components/StsLogin';

//Mesh
import Mesh from './pages/mesh/Mesh';


//Radio Motorola
import Radio from './pages/Radio/RadioPage';
function App() {
  const [formOpen, setFormOpen] = useState(false);

  return (
    <Router>
      <ScrollToTop />
      <ScrollToTopButton />
      <div className="App">
        <Header onContactClick={() => setFormOpen(true)} />

        <Routes>
          <Route
            path="/"
            element={
              <>
                <div className="relative">
                  <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none">
                    <div className="absolute inset-0 bg-gradient-to-br from-[#070b15] via-[#0b1330] to-[#070b15]" />
                    <div className="glow-orb w-[620px] h-[620px] bg-[#0070d2] opacity-30 -top-40 -left-32 [animation:drift-slow_24s_ease-in-out_infinite,glow-pulse_9s_ease-in-out_infinite]" />
                    <div className="glow-orb w-[520px] h-[520px] bg-[#00c2ff] opacity-30 -top-10 right-[-140px] [animation:drift_15s_ease-in-out_infinite_2s,glow-pulse_9s_ease-in-out_infinite_1.5s]" />
                  </div>
                  <div className="relative z-10">
                    <HeroSection onContactClick={() => setFormOpen(true)} />
                    <Services />
                    <KazakhMap />
                  </div>
                </div>
                <Partners />
              </>
            }
          />
          <Route path="/about" element={<AboutPage />} />

          <Route path="/video" element={<VideoSolutions />} />
          <Route path="/video/motorola" element={<MotorolaPage />} />
          <Route path="/video/wisenet" element={<WisenetPage />} />
          <Route path="/video/milestone" element={<MilestonePage />} />
          <Route path="/video/recfaces" element={<RecFacesPage />} />

          <Route path="/localsystems" element={<LocalSystems />} />
          <Route path="/antiterror" element={<AntiterrorSystems />} />
          <Route path="/digitalforensics" element={<DigitalForensics />} />
          <Route path="/drones" element={<DronesSection />} />
          <Route path="/antidrone" element={<AntidroneSystems />} />

          <Route path="/mesh" element={<Mesh />} />
          <Route path="/radio" element={<Radio />} />
          <Route path="/sts-login" element={<StsLogin />} />
          <Route
            path="/sts"
            element={
              <ProtectedRoute>
                <STSPage />
              </ProtectedRoute>
            }
          />
        </Routes>

        <Footer onContactClick={() => setFormOpen(true)} />


        {/* Модалка */}
        {formOpen && (
          <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[9999] p-4">
            <div className="glass-card relative w-full max-w-lg rounded-3xl p-8 bg-[#0a111f]/95">
              <button
                onClick={() => setFormOpen(false)}
                className="absolute top-4 right-5 text-white/50 hover:text-cyan-300 text-2xl font-bold transition"
              >
                &times;
              </button>
              <h2 className="font-display text-xl font-bold text-white mb-6">Связаться с нами</h2>
              <ContactForm />
            </div>
          </div>
        )}
      </div>
    </Router>
  );
}

export default App;
